"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.putWorksheetJsonData = void 0;
/**
 * S3 Presigned-URLs grant temporary access to an S3 bucket,  allowing the user to complete an action on the bucket,  in this case, uploading worksheet json, without requiring AWS credentials.
Shape of JSON should be `IWorksheetAnswersBody`

 */
var putWorksheetJsonData = function (instance) {
    return function (ref, worksheet, filename, body, config) {
        return instance.put("/worksheets/json/".concat(ref, "/").concat(worksheet, "/").concat(filename), body, config);
    };
};
exports.putWorksheetJsonData = putWorksheetJsonData;
